import { Icon } from "@/components/Icon";
import { CryptoMerchantInfo } from "@/stores/CryptoMerchatStore";
import { amountFormat } from "@/utils/tool";
import { Grid } from "antd-mobile";
import styles from "./BalanceDetail.module.scss";


const balance_items = [
  { text: "昨日收益", id: "yesterday",  color: "#FF9900" },
  { text: "近30日收益", id: "month",  color: "#01B14E" },
  { text: "预计年收益", id: "year",  color: "#F76260" },
];

type BalanceDetailProps = {
  userInfo: CryptoMerchantInfo;
};
export default function BalanceDetail({ userInfo }: BalanceDetailProps) {

  const renderMoney=(id:string)=>{
    let amount = '-';
    if( id === "yesterday" ){
      amount = amountFormat( userInfo.yesterday?.business_subsidy_balance_count, { places: 2 })
    }else if( id === "month" ){
      amount = amountFormat( userInfo.month?.business_subsidy_balance_count, { places: 2 })
    }else if( id === "year" ){
      amount = amountFormat( parseFloat(userInfo.month?.business_subsidy_balance_count)*12, { places: 2 })
    }
    return amount;
  }

  return (
    <Grid columns={3} gap={8} className={styles.balance_detail}>
      {balance_items.map((item) => (
        <Grid.Item key={item.id} className={styles.balance_detail_item}>
          <div className={styles.balance_detail_text}>{item.text}</div>
          <div
            className={styles.balance_detail_vol}
            style={{ color: item.color }}
          >
            {renderMoney(item.id)}
          </div>
          <div>
            <Icon name={"Vbi"} size={"24px"} />
          </div>
        </Grid.Item>
      ))}
    </Grid>
  );
}
